<!--<youtube-player-->
<!--  class="flex-1"-->
<!--  [width]="1920"-->
<!--  [height]="1080"-->
<!--  [playerVars]="playerVars"-->
<!--  [videoId]="videoId" />-->

<video #target class="video-js" autoplay controls></video>
